module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add":"Added","remove":"Removed","orderType":"Order Type","name":"Name","code":"Code","alternativeName":"Alternative Name","tripHandling":"Has trip handling"},"no":{"add":"Laget","remove":"Slettet","orderType":"Oppdragstype","name":"Navn","code":"Kode","alternativeName":"Alternativt navn","tripHandling":"Has trip handling"}}')
  delete Component.options._Ctor
}
